module.exports = __webpack_public_path__ + "static/img/2.393aa8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/eng/2.png
// module id = 4AXx
// module chunks = 0